import {
  OmakasePolymorphicComponent,
  OmakasePolymorphicComponentProps,
} from 'omakase/utils/OmakasePolymorphicComponent';
import {
  PadButtonCore,
  PadButtonCoreProps,
  PadButtonDefaultElement,
} from 'omakase/PadButton/PadButtonCore';
import React from 'react';

export type PadButtonTypeGuard = 'input';

export type PadButtonProps = PadButtonCoreProps;

const PadButton: OmakasePolymorphicComponent<
  PadButtonProps,
  typeof PadButtonDefaultElement,
  PadButtonTypeGuard
> = React.forwardRef(
  <E extends React.ElementType = typeof PadButtonDefaultElement>(
    { component, ...rest }: OmakasePolymorphicComponentProps<PadButtonProps, E, PadButtonTypeGuard>,
    ref: React.Ref<HTMLInputElement> | undefined
  ) => {
    const Component: React.ElementType = component || PadButtonDefaultElement;

    return (
      <PadButtonCore
        {...rest}
        component={Component}
        ref={ref}
        borderRadius="small"
        verticalSpacing="large"
      />
    );
  }
);

export default PadButton;
